<script setup>
import SelectType from "@/components/trackers/trackerEdit/SelectType.vue";
import {computed, provide, ref, watch} from "vue";
import {accountTypeFree, accountTypePremium} from "@/constants/accountTypes";
import {useStore} from "vue2-helpers/vuex";
import trackersService from "@/services/trackers.service";
import constants from "@/constants/constants";
import {triggerUpgrade} from "@/composables/useStoreActions";
import TrackerEdit from "@/components/trackers/trackerEdit/TrackerEdit.vue";
import {trackerTypes} from "@/constants/trackers";
import ProjectEdit from "@/components/projects/ProjectEdit.vue";

const {folderId = 0, folderType = null} = defineProps(['folderId', 'folderType']);
const emit = defineEmits(['trackerSaved']);

const store = useStore();
const id = ref(null);
const showModal = ref(false);
const step = ref(1);
const disabledTypeSelection = ref(false);
const trackerType = ref(null);
const isNew = ref(true);
const selectTypeBlock = ref(null);

const showPrevStepButton = computed(() => step.value === 2 && !id.value && store.state.accountType !== accountTypeFree && !disabledTypeSelection.value);

watch(showModal, value => {
    if (value) {
        document.body.classList.add('modal-open');
    } else {
        document.body.classList.remove('modal-open');
    }
});

function setType(type) {
    trackerType.value = type;
    step.value++;
}

async function open(trackerId = 0, type = null) {
    id.value = trackerId;
    isNew.value = !trackerId;

    if (type) {
        disabledTypeSelection.value = true;
        step.value = 2;
    } else {
        disabledTypeSelection.value = false;
        step.value = 1;
    }

    let canOpen = true;

    if (!id.value && store.state.accountType !== accountTypePremium) {
        const {data} = await trackersService.getCount();

        if (data >= constants.enterpriseLimits.trackers[store.state.accountType]) {
            triggerUpgrade(store, 'trackers');
            canOpen = false;
        }
    }

    if (canOpen) {
        showModal.value = true;

        if (type) {
            trackerType.value = type;
        }
    }
}

function saved() {
    showModal.value = false;
    emit('trackerSaved', id.value);
}

defineExpose({
    open,
});

provide('isNew', isNew);
provide('trackerId', id);
provide('trackerType', trackerType);
provide('folderId', folderId);
provide('folderType', folderType);
</script>

<template>
    <div v-if="showModal" class="modal-edit-tracker modal-edit-tracker--sub modal-edit-creation-tracker">
        <header class="modal-header">
            <button type="button" aria-label="Close" class="close" @click="showModal = false"></button>
            <b-button v-if="showPrevStepButton" variant="primary" size="lg" @click="step--" class="back-link"></b-button>
            <b-button v-if="selectTypeBlock?.showTypes" variant="primary" size="lg" @click="selectTypeBlock.showTypes = false" class="back-link"></b-button>
        </header>

        <SelectType
            v-if="step === 1"
            ref="selectTypeBlock"
            @setType="setType"
        />

        <div v-else class="modal-sub">
            <div class="modal-sub__inner">
                <ProjectEdit
                    v-if="trackerType === trackerTypes.PROJECT"
                    @projectSaved="saved"
                />

                <TrackerEdit
                    v-else
                    @trackerSaved="saved"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
